import { Avatar } from '@/components/Avatar';
import { Icon } from '@/components/Icon';
import { getTgUser } from '@/lib/telegram';

export function ProfilePage(): JSX.Element {
  const tg = getTgUser();
  const name = tg ? `${tg.first_name}${tg.last_name ? ' ' + tg.last_name : ''}` : 'Гость';

  return (
    <div className="space-y-4">
      <header>
        <p className="text-2xs uppercase tracking-widest text-ink-500">профиль</p>
        <h1 className="font-display text-2xl font-bold text-ink-50">{name}</h1>
        {tg?.username && <p className="mt-1 text-sm text-ink-300">@{tg.username}</p>}
      </header>

      <div className="card-hero p-5">
        <div className="relative z-10 flex items-center gap-4">
          <Avatar name={name} src={tg?.photo_url} size={56} />
          <div>
            <div className="text-2xs uppercase tracking-widest text-ink-100/70">всего за неделю</div>
            <div className="text-2xl font-bold text-ink-50">3 240 постов</div>
            <div className="text-sm text-ink-300">+82 ЛС · +147 пингов</div>
          </div>
        </div>
      </div>

      <ul className="space-y-2">
        <Row icon="settings"  label="Настройки" sub="язык, тема, уведомления" />
        <Row icon="upload"    label="Прокси-пул" sub="загрузить · проверить" />
        <Row icon="shield"    label="Безопасность" sub="2FA, лимиты по умолчанию" />
        <Row icon="message"   label="Документация · API"  sub="Swagger, Bull-board" />
      </ul>
    </div>
  );
}

function Row({ icon, label, sub }: { icon: any; label: string; sub: string }): JSX.Element {
  return (
    <li className="card flex items-center gap-3 p-3">
      <span className="icon-circle-ghost"><Icon name={icon} /></span>
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold text-ink-50">{label}</div>
        <div className="text-2xs text-ink-500">{sub}</div>
      </div>
      <Icon name="chevron-right" className="text-ink-500" />
    </li>
  );
}
